import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { useAssetsData } from 'modules/pools/hooks/useAssetsData'

import { FormattedDate } from 'shared/ui/utils/FormattedDate'
import { TableRow } from 'shared/ui/common/Table'
import { TransactionStatusBadge } from 'modules/blockChain/ui/TransactionStatusBadge'
import { InfoFieldValue } from 'shared/ui/common/InfoFieldValue'
import { TransactionRowAmount } from './TransactionRowAmount'
import { ReactComponent as LinkSVG } from 'assets/link.svg'

import { getTxTypeDisplayText } from 'modules/transactions/utils/getTxTypeDisplayText'
import { getNativeTokenLabel } from 'modules/pools/utils/getNativeTokenLabel'
import { getBlockExplorerLink } from 'modules/blockChain/utils/getBlockExplorerLink'
import { formatAsset } from 'modules/pools/utils/formatAsset'
import { weiToStr } from 'modules/blockChain/utils/parseWei'
import { TransactionFormatted } from 'modules/network/types'

import s from './TransactionRow.module.scss'

type Props = {
  tx: TransactionFormatted
}

export function TransactionRow({ tx }: Props) {
  const { chainId } = useWeb3()
  const nativeToken = getNativeTokenLabel(chainId)
  const { getAssetDecimals } = useAssetsData()
  const assetDecimals = getAssetDecimals(nativeToken)

  const gasPriceParsed = weiToStr(tx.gasPrice, assetDecimals)
  const gasPriceFormatted = formatAsset(gasPriceParsed, nativeToken)

  return (
    <TableRow gridTemplateColumns="repeat(5, 2fr) repeat(1, 24px)">
      <div>{getTxTypeDisplayText(tx.transactionType)}</div>

      <InfoFieldValue
        value={<FormattedDate format="DD–MMM–YYYY" date={tx.timestamp} />}
        secondaryValueSize={16}
        secondaryValue={
          <FormattedDate format="hh:mm:ss a" date={tx.timestamp} />
        }
      />

      <div>
        <TransactionStatusBadge status="success" />
      </div>

      {tx.amount && tx.asset ? (
        <TransactionRowAmount amount={tx.amount} asset={tx.asset} />
      ) : (
        '—'
      )}

      <InfoFieldValue
        value={gasPriceFormatted}
        sign={nativeToken}
        tooltip={gasPriceParsed}
      />

      <a
        target="_blank"
        rel="noreferrer"
        href={getBlockExplorerLink(chainId, tx.id)}
        className={s.link}
      >
        <LinkSVG />
      </a>
    </TableRow>
  )
}
